import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  provide_withdrawal_rights_flag: {
    name: 'Withdrawal redemption rights flag',
    order: 193
  },
  investor_redemption_frequency: {
    name: 'Investor Redemption Frequency',
    order: 194
  },
  investor_redemption_notice_period: {
    name: 'Investor Redemption Notice Period',
    order: 195
  },
  investor_redemption_lockup_period: {
    name: 'Investor Redemption Lock Up Period',
    order: 196
  }
};

export function LiquidityRedemption2({
  onChangeFund,
  funds,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.INVESTOR_LIQUIDITY_PROFILE,
    onChangeFund,
    schema: schema.INVESTOR_LIQUIDITY_PROFILE,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.INVESTOR_LIQUIDITY_PROFILE?.field_names || [],
    columnLables,
    isMultiFunds,
    funds,
    tableName: 'INVESTOR_LIQUIDITY_PROFILE'
  });

  return (
    <Table
      id="reporttables-liquidity-redemption-2-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
